import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Products } from "../components/Products";
import { About } from "../components/About";
import { PopUps } from "../components/PopUps";
import { ContactForm } from "../components/ContactForm";
import { Footer } from "../components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#FAF9F6] text-[#2C1E16]">
      <Header />
      <Hero />
      <Products />
      <About />
      <PopUps />
      <ContactForm />
      <Footer />
    </main>
  );
}
